import { useRoute } from 'vue-router';
import { defineComponent } from "vue";
import VueCookie from 'vue-cookie'

/* eslint-disable */
export default defineComponent({
   name: "sidebar",
   computed: {
      route: () => useRoute()
   },
   mounted() {
      this.customerName = VueCookie.get("name");
      this.url = process.env.BASE_URL;
      this.support_number = process.env.VUE_APP_WHATSAPP_SUPPORT_NUMBER;
   },
   data() {
      return {
         customerName: '',
         url: '',
         support_number: ''
      };
   },
   methods: {
   },
});
